import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthenticationGuard} from './core/services/auth/authentication.guard';
import { MenuGuard } from './shared/guards/menu/menu.guard';

const routes: Routes = [
  // Fallback when no prior route is matched
  {
    path: 'auth',
    loadChildren: () => import('./main/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'sales',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/sales/sales.module').then(m => m.SalesModule)
  },
  {
    path: 'sellapp',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/sellapp/sell.module').then(m => m.SellAppModule)
  },
  {
    path: 'commissions',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/commissions/commissions.module').then(m => m.CommissionsModule)
  },
  {
    path: 'settings',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/setting/setting.module').then(m => m.SettingModule)
  },
  {
    path: 'master',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/master/master.module').then(m => m.MasterModule)
  },
  {
    path: 'users',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'revenue',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/revenue/revenue.module').then(m => m.RevenueModule)
  },
  {
    path: 'email-activate',
    canActivateChild: [AuthenticationGuard, MenuGuard],
    loadChildren: () => import('./main/email-validate/email-validate.module').then(m => m.EmailValidateModule)
  },
  {path: '', redirectTo: 'auth', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {
}
